/**
 * Global Antd theme for every shortcode — mirrors the devowl.io site
 * palette (`usof_options_Impreza`). Input fields use a subtle off-white
 * (`FORM_FIELD_BG`) above Antd's disabled-grey so active inputs don't
 * read as disabled.
 */ const FORM_FIELD_BG = "#fafbfc";
const FORM_FIELD_BORDER = "#d9d9d9";
const FORM_FIELD_RADIUS = 2;
const COLOR_PRIMARY_SOFT_BG = "#ebf5fa";
const COLOR_ERROR_SOFT = "#de5050";
// Deeper shade of `COLOR_ERROR_SOFT` for gradient mid-stops.
const COLOR_ERROR_SOFT_DEEP = "#c44545";
// Deeper shade of `colorPrimary` for brand-cyan gradient mid-stops.
const COLOR_PRIMARY_DEEP = "#369fc9";
// Light tint of `colorSuccess` for the cumulative-growth area gradient far stop.
const COLOR_SUCCESS_SOFT = "#9fe3c4";
// Status-pill hues — kept literal because AntD's colorSuccessBg/Text family
// lands on different shades than the V2 design specifies.
const COLOR_STATUS_ACTIVE_BG = "rgba(82, 196, 26, 0.12)";
const COLOR_STATUS_ACTIVE_TEXT = "#389e0d";
const COLOR_STATUS_WARNING_BG = "rgba(250, 173, 20, 0.16)";
const COLOR_STATUS_WARNING_TEXT = "#d48806";
const COLOR_STATUS_ERROR_BG = "rgba(255, 77, 79, 0.12)";
const COLOR_STATUS_ERROR_TEXT = "#cf1322";
const COLOR_STATUS_NEUTRAL_BG = "rgba(0, 0, 0, 0.06)";
const COLOR_STATUS_NEUTRAL_TEXT = "rgba(0, 0, 0, 0.55)";
const antdTheme = {
    token: {
        colorPrimary: "#45b3dd",
        colorSuccess: "#3f8600",
        colorWarning: "#FFCC3E",
        borderRadius: 2,
        fontSize: 15,
        colorText: "#666666",
        colorTextHeading: "#3d3d3d",
        colorTextSecondary: "#999999",
        colorTextPlaceholder: "#8c8c8c",
        colorBorder: "#e8e8e8",
        colorBgContainer: "#ffffff",
        colorBgLayout: "#f5f9fc",
        colorBgElevated: "#ffffff",
        colorLink: "#45b3dd",
        colorLinkHover: "#469bc3"
    },
    components: {
        // Sticky tab-nav (z-index: 10) must sit above Dropdown context menus.
        // Setting zIndexPopup: 9 keeps dropdowns below the nav while leaving
        // Modals (1000+) and Tooltips (1070) unaffected.
        Dropdown: {
            zIndexPopup: 9
        },
        // Match Impreza `w-btn`: ~48 px tall, 17 px copy, weight 700; gradient bg via formFields.scss.
        Button: {
            colorPrimaryHover: "#469bc3",
            borderRadius: 2,
            fontWeight: 700,
            controlHeightLG: 48,
            fontSizeLG: 17,
            paddingInlineLG: 30
        },
        Table: {
            colorBgContainer: "white"
        },
        Input: {
            colorBgContainer: FORM_FIELD_BG,
            colorBorder: FORM_FIELD_BORDER,
            borderRadius: FORM_FIELD_RADIUS
        },
        InputNumber: {
            colorBgContainer: FORM_FIELD_BG,
            colorBorder: FORM_FIELD_BORDER,
            borderRadius: FORM_FIELD_RADIUS
        },
        Select: {
            colorBgContainer: FORM_FIELD_BG,
            colorBorder: FORM_FIELD_BORDER,
            borderRadius: FORM_FIELD_RADIUS
        },
        DatePicker: {
            colorBgContainer: FORM_FIELD_BG,
            colorBorder: FORM_FIELD_BORDER,
            borderRadius: FORM_FIELD_RADIUS
        },
        Cascader: {
            colorBgContainer: FORM_FIELD_BG
        },
        Mentions: {
            colorBgContainer: FORM_FIELD_BG,
            colorBorder: FORM_FIELD_BORDER,
            borderRadius: FORM_FIELD_RADIUS
        }
    }
};
export { antdTheme, FORM_FIELD_BG, FORM_FIELD_BORDER, COLOR_PRIMARY_SOFT_BG, COLOR_ERROR_SOFT, COLOR_ERROR_SOFT_DEEP, COLOR_PRIMARY_DEEP, COLOR_SUCCESS_SOFT, COLOR_STATUS_ACTIVE_BG, COLOR_STATUS_ACTIVE_TEXT, COLOR_STATUS_WARNING_BG, COLOR_STATUS_WARNING_TEXT, COLOR_STATUS_ERROR_BG, COLOR_STATUS_ERROR_TEXT, COLOR_STATUS_NEUTRAL_BG, COLOR_STATUS_NEUTRAL_TEXT };
